import React from 'react';
import { useNavigate } from 'react-router-dom';

const CreateVigilance = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-white flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        {/* Header */}
        <div className="text-center">
          <img
            src={`${process.env.PUBLIC_URL}/logo192.png`}
            alt="SJVN Limited Logo"
            className="w-18 h-24 mx-auto mb-4"
            role="img"
            aria-label="SJVN Limited Logo"
          />
          <h2 className="text-3xl font-bold text-gray-900 mb-2">Vigilance Portal</h2>
          <p className="text-gray-600">Access the vigilance complaint system</p>
          <div className="w-24 h-1 bg-primary-600 mx-auto mt-4"></div>
        </div>

        {/* Action Buttons */}
        <div className="bg-white rounded-xl shadow-lg p-8">
          <div className="space-y-6">
            <div className="text-center">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Choose an option</h3>
              <p className="text-sm text-gray-600 mb-2">
                Select whether you want to login to your existing account or create a new one
              </p>
            </div>

            {/* Login Button */}
            <button
              onClick={() => navigate('/vigilance-login')}
              className={`w-full bg-gradient-to-r from-primary-600 to-primary-700 text-white py-4 px-6 rounded-lg font-semibold transition-all duration-300 focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 shadow-md hover:shadow-lg hover:from-primary-700 hover:to-primary-800`}
            >
              <div className="flex items-center justify-center space-x-3">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
                </svg>
                <span>Login to Existing Account</span>
              </div>
            </button>

            {/* Signup Button */}
            <button
              onClick={() => navigate('/vigilance-signup')}
              className={`w-full bg-gradient-to-r from-green-600 to-green-700 text-white py-4 px-6 rounded-lg font-semibold transition-all duration-300 focus:ring-2 focus:ring-green-500 focus:ring-offset-2 shadow-md hover:shadow-lg hover:from-green-700 hover:to-green-800`}
            >
              <div className="flex items-center justify-center space-x-3">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
                </svg>
                <span>Create New Account</span>
              </div>
            </button>

            {/* Validate Yourself Button */}
            <button
              onClick={() => navigate('/vigilance-validation')}
              className={`w-full bg-gradient-to-r from-orange-500 to-orange-600 text-white py-4 px-6 rounded-lg font-semibold transition-all duration-300 focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 shadow-md hover:shadow-lg hover:from-orange-600 hover:to-orange-700`}
            >
              <div className="flex items-center justify-center space-x-3">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
                <span>Validate Yourself</span>
              </div>
            </button>

            {/* Additional Options */}
            <div className="pt-6 border-t border-gray-200">
              <div className="text-center">
                <p className="text-sm text-gray-600 mb-2">Other Options</p>
                <div className="space-y-2">
                  <button
                    onClick={() => navigate('/vigilance-status')}
                    className="w-full text-primary-600 hover:text-primary-700 font-medium transition-colors duration-300 py-2"
                  >
                    Check Complaint Status
                  </button>
                  <button
                    onClick={() => navigate('/vigilance-login')}
                    className="w-full text-gray-600 hover:text-gray-700 font-medium transition-colors duration-300"
                  >
                    ← Back to Login
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateVigilance;